import { render, staticRenderFns } from "./TournamentCard.vue?vue&type=template&id=780f8acc"
import script from "./TournamentCard.vue?vue&type=script&lang=js"
export * from "./TournamentCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentCard.vue?vue&type=style&index=0&id=780f8acc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports